import React, { useEffect, useState, useRef } from 'react';
import { BASE_URL } from '../../config/axios';
import axios from 'axios';
import Modal from "react-bootstrap/Modal";
import { ToastContainer, toast } from "react-toastify";
import { handleErrorToast, sortProjects } from '../CustomFunctions';
import { saveAs } from 'file-saver';
import Dashboardnavbar from '../../layout/Dashboardnavbar';
import "jspdf-autotable";
import {
    AddwithWhiteCircle,
    DropdownArrow,
    DocumentIcon,
    DownloadIcon,
    Filter,
    Office,
    CircularGrid,
    DeleteDustbin,
    Attachment,
    SearchSmall,
    Eye,
    UpdatePencilWhite,
    UpdatePencil
} from "../AllSvg";

import {
    DocumentSection,
    RenderSelectField,

} from "../FormdataComponent";
import Select from "react-select";
import JSZip from 'jszip';
import { use } from 'react';
import { useNavigate } from "react-router-dom";

const FinalizeBidList = ({ projectId, letterBy, contractor, contractorlist }) => {
    const tableRef = useRef(null);
    const [toggleCompany, setToggleCompany] = useState("null");
    const [siteSubCompanyList, setSiteSubCompanyList] = useState([]);
    const navigate = useNavigate();


    const [workperformedby, setWorkperformedby] = useState("null");

    const [lettertype, setLetterType] = useState("null");
    const [structureList, setstructureList] = useState([]);
    const [filteredData, setFilteredData] = useState([]);

    const [error, setError] = useState(null);

    const [selectedNo, setNo] = useState("");
    const [selectedFromDate, setFromDate] = useState("null");
    const [selectedToDate, setToDate] = useState("null");
    const [structure, setStructure] = useState("null");
    const [sector, setSector] = useState("null");
    const [service, setService] = useState("null");
    const [selectedProject, setSelectedProject] = useState("null");
    const [searchQuery, setSearchQuery] = useState("");
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };
    const [trackRecordList, setTrackRecordList] = useState([]);


    const [buffer, setBuffering] = useState(true); //buffering logic


    const getcompany = async () => {
        setBuffering(true); // Start Buffering
        try {

            const sub = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSiteSubCompanyList(sub.data);



        } catch (err) {
            // handleErrorToast(err); // You can handle any general error here if needed
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    const getStructure = async () => {
        try {
            const getStr = await axios.get(`${BASE_URL}/siteproject/structuredetail/`);
            setstructureList(getStr.data);

        } catch (error) {
            console.error(error);

        }
    }
    const [projectList, setProjectList] = useState([]);
    const [bidData, SetBidData] = useState([]);
    const getProject = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const pro = await axios.get(`${BASE_URL}/siteproject/projectfilterbysubcompany/${toggleCompany}/`);

            SetBidData(pro.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    };
    const getBidData = async () => {
        setBuffering(true); // Start Buffering
        try {

            // const res = await axios.get(${BASE_URL}/siteproject/certifications/);
            const res = await axios.get(`${BASE_URL}/siteproject/BidTenders/`);
            SetBidData(res.data);


        } catch (err) {
            // handleErrorToast(err); // You can handle any general error here if needed
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        getcompany();
        getStructure();
    }, []);



    useEffect(() => {
        getBidData();

    }, []);




    useEffect(() => {

        applyFilters();

    }, [searchQuery, bidData]);

    const applyFilters = () => {
        let filteredData = bidData;

        if (searchQuery !== "") {
            const lowercaseSelectedName = searchQuery.toLowerCase();
            filteredData = filteredData.filter(data => {
                const lid = data?.name_of_work?.toString().toLowerCase().includes(lowercaseSelectedName);
                console.log(lid, 'filteredata')
                return lid;
            });
        }


        setFilteredData(filteredData);
    };


    const [toggleState, setToggleState] = useState(1);
    const ViewAllBidDetails = (project, data) => {
        navigate(`/certificaionaccess/bidDetails/`, {
            state: { project, data }
        });
    };
    return (
        <>



            <div className="attendance-history-cont">



                <div className="table-css-white-background  table-box paddingTop-0px scroll-container-table" style={{ minHeight: "380px" }} >
                    <table ref={tableRef} className="table-css">
                        <thead className="table-heading">
                            <tr className="custom-table-head-tr">
                                <th className="table-heading-text">Sr no.</th>
                                <th className="table-heading-text">Sector</th>
                                <th className="table-heading-text">Tender Type</th>
                                <th className="table-heading-text">Client</th>
                                <th className="table-heading-text">Tender Name</th>
                                <th className="table-heading-text">Submission Date</th>
                                <th className="table-heading-text">Lane</th>
                                <th className="table-heading-text">State</th>
                                <th className="table-heading-text">Cost of Consult</th>
                                <th className="table-heading-text">Length</th>
                                <th className="table-heading-text">Cost Of construction</th>
                                <th className="table-heading-text">Duration</th>
                                <th className="table-heading-text">Status</th>
                                <th className="table-heading-text">Lead Partner</th>
                                <th className="table-heading-text">Jv Partner</th>
                                <th className="table-heading-text">Associate with Version</th>
                                <th className="table-heading-text">Document</th>
                                <th className="table-heading-text">Emd</th>
                                <th className="table-heading-text">Eligibity Criteria</th>
                                <th className="table-heading-text">Remarks</th>
                                <th className="table-heading-text text-center">Actions</th>
                            </tr>
                        </thead>
                        {buffer ? (
                            <div className="spinner-bgdatil"></div>
                        ) : error ? (
                            <p>Error fetching data: {error.message}</p>
                        ) : (
                            <tbody>
                                {filteredData.filter((i) => i?.is_finalize).map((i, index) => (
                                    <tr key={i.id} className="custom-table-head-td">
                                        <td className='table-body'>{index + 1}.</td>
                                        <td className='table-body'>{i?.sector}</td>
                                        <td className='table-body'>{i?.tender_type}</td>
                                        <td className='table-body'>{i?.client}</td>
                                        <td className='table-body'>{i?.tender_name}</td>
                                        <td className='table-body'>{i?.submission_date}</td>
                                        <td className='table-body'>{i?.lane}</td>
                                        <td className='table-body'>{i?.state}</td>
                                        <td className='table-body'>{i?.cost_of_consult}</td>
                                        <td className='table-body'>{i?.length}</td>
                                        <td className='table-body'>{i?.cost_of_construction}</td>
                                        <td className='table-body'>{i?.duration}</td>
                                        <td className='table-body'>{i?.status}</td>
                                        <td className='table-body'>{i?.lead_partner}</td>
                                        <td className='table-body'>{i?.jv_partner}</td>
                                        <td className='table-body'>{i?.associate_with_version}</td>
                                        <td className='table-body'>
                                            {i?.document ? (
                                                <a href={i?.document} target="_blank" rel="noopener noreferrer">
                                                    <DocumentIcon />
                                                </a>
                                            ) : ""}
                                        </td>
                                        <td className='table-body'>{i?.emd}</td>
                                        <td className='table-body'>{i?.eligibity_criteria}</td>
                                        <td className='table-body'>{i?.remarks}</td>
                                        <td className='table-body text-center'>
                                            <div className='flex' style={{ display: 'flex', gap: '5px' }}>
                                                {/* <span onClick={() => ViewAllBidDetails(i.id, i)}><Eye /></span> */}
                                                {/* <Addtocart i={i} getBid={getBidData} />
                            <UpdateBidDetails i={i} getBidData={getBidData} /> */}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        )}
                    </table>
                </div>
            </div>

        </>
    );
}

export default FinalizeBidList;